__turbopack_context__.v({
  "card-wrapper": "style-module-scss-module__dPVDpW__card-wrapper",
  "minimal-listings": "style-module-scss-module__dPVDpW__minimal-listings",
  "similar-listings": "style-module-scss-module__dPVDpW__similar-listings",
});
